<script setup>
import {RouterView, useRouter} from 'vue-router'
import TopBar from "@/components/TopBar.vue";
import Footer from "@/components/Footer.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {useAppStore} from "./stores/app";
import {storeToRefs} from "pinia";
import {computed, onMounted} from "vue";
import {EndpointsFactory} from "@/utilities/endpoints";
import {useI18n} from "vue-i18n";
import {URLS_FACTORY} from "./router/urls.js";
import {useDomStore} from "@/stores/dom.js";

const appStore = useAppStore();
const {
  loading,
  errorData,
  error,
  saveOkFeedback,
  expiredLogout,
  snackbarText,
  snackbar
} = storeToRefs(appStore);
const $router = useRouter();
const domStore = useDomStore();
const {t: $t, locale} = useI18n();

const errorBody = computed(() => errorData.value.body ? errorData.value.body : $t('global.generic_error'));

onMounted(async () => {
  EndpointsFactory.initWorker(new Worker(new URL('@/FetchWebWorker.js', import.meta.url), {type: 'module'}));
  await domStore.loadDomData(null, locale.value, false, true);
  appStore.hideSpinner();
});

function okError(){
  if(expiredLogout.value){
    expiredLogout.value = false;
    $router.push(URLS_FACTORY.URLS_PATHS.ROOT).then();
  }
  appStore.hideError();
}
</script>

<template>
  <v-layout full-height>
    <loading-spinner v-show="loading"></loading-spinner>
    <div v-if="saveOkFeedback" class="wrapper-save">
      <div class="box-save">
        <i class="mdi mdi-floppy"></i>
        <div>{{ $t('global.saved') }}</div>
      </div>
    </div>
    <v-app>
      <top-bar></top-bar>
      <v-main>
        <router-view/>

        <!-- dialog di errore -->
        <v-dialog v-model="error" class="dialog-primary dialog-error" width="auto">
          <v-card>
            <v-card-title>
              <v-icon icon="mdi-message-alert"></v-icon>
              {{ errorData.title }}
            </v-card-title>
            <v-card-text><span v-html="errorBody"></span></v-card-text>
            <v-card-actions class="gen-wrapper-btn">
              <v-btn class="m-btn secondary-light" @click="okError">
                {{ errorData.okBtn ? errorData.okBtn : $t('global.ok') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar">
          {{ snackbarText }}
        </v-snackbar>
      </v-main>
      <Footer></Footer>
    </v-app>
  </v-layout>
</template>

<style lang="less" scoped></style>
